// Carte primitive — DESIGN-GUIDE section 3 (rounded-2xl) + tokens de theme.
// variant : default (surface translucide) | glass (liquid glass) | solid (opaque)

const VARIANTS = {
  default: 'bg-card border border-card-border',
  glass: 'glass-surface',
  solid: 'bg-bg border border-card-border',
}

export default function Card({ variant = 'default', as: Tag = 'div', className = '', children, ...props }) {
  const variantCls = VARIANTS[variant] || VARIANTS.default
  return (
    <Tag className={`rounded-2xl ${variantCls} ${className}`.trim()} {...props}>
      {children}
    </Tag>
  )
}
